import React from 'react';

const AI = () => (
  <div className="min-h-screen bg-white flex flex-col items-center justify-center px-0 py-0 animate__animated animate__fadeIn">
    {/* Hero Section */}
    <section className="w-full min-h-[80vh] flex flex-col justify-center items-center bg-gradient-to-br from-[#f8fafc] to-[#e8f5e9] px-4 sm:px-8 text-center">
      <div className="max-w-3xl mx-auto py-24 flex flex-col items-center justify-center">
        <h1 className="text-4xl sm:text-6xl font-bold text-gray-900 mb-6 leading-tight">AI Consulting & Implementation</h1>
        <p className="text-lg sm:text-2xl text-gray-700 mb-10 max-w-2xl">Custom AI solutions for small businesses and high-performing individuals. Automate, optimize, and unlock new growth with Imaginex.</p>
                        <a href="mailto:theimaginexcompany@gmail.com" className="inline-block px-10 py-4 bg-[#618A3D] text-white font-bold rounded-lg shadow-lg hover:bg-[#75a64b] transition text-lg">Get Started with AI</a>
      </div>
    </section>

    {/* Small Business Section */}
    <section className="w-full max-w-6xl mx-auto py-12 px-4 sm:px-8 flex flex-col lg:flex-row items-center gap-12">
      <div className="flex-1 order-2 lg:order-1">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">AI-Powered Growth for Small Businesses</h2>
        <p className="text-lg sm:text-xl text-gray-700 mb-6">Custom automation, private AI models, and intelligent systems to scale your company faster.</p>
        <ul className="mb-6 space-y-3 text-left">
          <li className="flex items-start text-base sm:text-lg"><span className="text-[#618A3D] text-xl mr-2">✦</span> <span><b>AI Automation:</b> Automated workflows for customer support, scheduling, lead nurturing, and more.</span></li>
          <li className="flex items-start text-base sm:text-lg"><span className="text-[#618A3D] text-xl mr-2">✦</span> <span><b>Private LLM Development:</b> Proprietary language models trained on your internal data for a competitive edge.</span></li>
          <li className="flex items-start text-base sm:text-lg"><span className="text-[#618A3D] text-xl mr-2">✦</span> <span><b>Custom Business Systems:</b> From booking assistants to AI-driven team management and analytics dashboards.</span></li>
        </ul>
        <p className="text-gray-700 font-medium mb-8">Save hours. Cut costs. Scale operations. We build what your team needs to win.</p>
                        <a href="mailto:theimaginexcompany@gmail.com" className="inline-block px-8 py-4 bg-[#618A3D] text-white font-bold rounded-lg shadow-lg hover:bg-[#75a64b] transition text-lg">Book AI Strategy Call</a>
      </div>
      <div className="flex-1 order-1 lg:order-2 flex justify-center mb-8 lg:mb-0">
        <img src="/images/tech.jpg" alt="AI for Business" className="rounded-xl shadow-lg w-full max-w-md object-cover" />
      </div>
    </section>

    {/* Data/Impact Section */}
    <section className="w-full max-w-5xl mx-auto py-8 px-4 sm:px-8">
      <div className="flex flex-col md:flex-row items-center justify-center gap-8">
        <div className="flex-1 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-2">AI Impact by the Numbers</h3>
          <div className="flex flex-wrap justify-center gap-8 mt-6">
            <div className="min-w-[120px]">
              <div className="text-4xl font-bold text-[#618A3D]">40%</div>
              <div className="text-gray-700 text-sm mt-1">Avg. cost savings with automation</div>
            </div>
            <div className="min-w-[120px]">
              <div className="text-4xl font-bold text-[#618A3D]">3x</div>
              <div className="text-gray-700 text-sm mt-1">Faster project delivery</div>
            </div>
            <div className="min-w-[120px]">
              <div className="text-4xl font-bold text-[#618A3D]">24/7</div>
              <div className="text-gray-700 text-sm mt-1">AI never sleeps</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Private Clients Section */}
    <section className="w-full max-w-6xl mx-auto py-12 px-4 sm:px-8 flex flex-col lg:flex-row items-center gap-12">
      <div className="flex-1 flex justify-center mb-8 lg:mb-0">
        <img src="/images/Code.jpg" alt="AI for Private Clients" className="rounded-xl shadow-lg w-full max-w-lg object-contain" />
      </div>
      <div className="flex-1">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">Automate Your Life and Multiply Your Income</h2>
        <p className="text-lg sm:text-xl text-gray-700 mb-6">Private AI agents and personalized tech that save time—and build wealth.</p>
        <ul className="mb-6 space-y-3 text-left">
          <li className="flex items-start text-base sm:text-lg"><span className="text-[#618A3D] text-xl mr-2">✦</span> <span><b>Personal AI Agents:</b> Schedule optimization, travel planning, content management, life assistance.</span></li>
          <li className="flex items-start text-base sm:text-lg"><span className="text-[#618A3D] text-xl mr-2">✦</span> <span><b>Income Diversification Program:</b> We use AI to help design, launch, and automate alternate revenue streams—e-commerce, content monetization, affiliate platforms, and more.</span></li>
          <li className="flex items-start text-base sm:text-lg"><span className="text-[#618A3D] text-xl mr-2">✦</span> <span><b>Custom Automations:</b> Build systems that automate complex or repetitive personal processes.</span></li>
        </ul>
        <p className="text-gray-700 font-medium mb-8">Reclaim your time and unlock new income paths—all powered by intelligent automation.</p>
                        <a href="mailto:theimaginexcompany@gmail.com" className="inline-block px-8 py-4 bg-[#618A3D] text-white font-bold rounded-lg shadow-lg hover:bg-[#75a64b] transition text-lg">Apply for Private AI Build</a>
      </div>
    </section>
  </div>
);

export default AI; 